import "../../../shared/animations/animate.css";
import AnimatedBody from "../../../shared/animations/AnimatedBody.tsx";
import AnimatedTitle from "../../../shared/animations/AnimatedTitle.tsx";
import {
  SiGit,
  SiPostgresql,
  SiNextdotjs,
  SiReact,
  SiTypescript,
  SiCsharp,
  SiFigma,
  SiDocker,
} from "react-icons/si";
import AnimatedTools from "../../../shared/animations/AnimatedTools.tsx";
import { toolsText } from "../../../../../data/index.ts";
import { IconType } from "react-icons";
import React, { cloneElement } from "react";

const Tools = () => {
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pb-36 pt-16 md:pb-44 md:pt-20 lg:pb-56 lg:pt-20"
      id="tools"
    >
      <div className="mx-auto flex w-[90%] flex-col items-center justify-center lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={toolsText.title}
          className={
            "mb-10 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="mx-auto w-[100%] justify-center lg:max-w-[1200px]">
          <TechSection name="Frontend" delay={0.2}>
            <SiTypescript size={50} />
            <SiReact size={50} />
            <SiNextdotjs size={50} />
          </TechSection>
          <TechSection name="Backend" delay={0.3}>
            <SiCsharp size={50} />
            <SiPostgresql size={50} />
          </TechSection>
          <TechSection name="Other" delay={0.4}>
            <SiGit size={50} />
            <SiFigma size={50} />
            <SiDocker size={50} />
          </TechSection>
        </div>
      </div>
    </section>
  );
};

const TechSection = ({
  name,
  delay,
  children,
}: {
  name: string;
  delay: number;
  children: React.ReactElement<React.ComponentProps<IconType>>[];
}) => {
  return (
    <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-bold leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[40px] md:leading-relaxed lg:mb-16 lg:w-[50%]">
      <AnimatedBody delay={delay} text={name} />
      <div>
        <AnimatedTools
          className="grid grid-cols-5 gap-4"
          delay={delay}
          stepSize={0.1}
          iconSize={50}
        >
          {children.map((child, index) =>
            cloneElement(child, { key: index, size: 50 })
          )}
        </AnimatedTools>
      </div>
    </div>
  );
};

export default Tools;
